"use strict";

/* -------------------------------------------------------------------------

	PUNITED.common

	サイト内で共通のスクリプトを定義
	※jQuery必須
	Potential United inc.

------------------------------------------------------------------------- */
// グローバル名前空間定義
var PUNITED;
if (!PUNITED) PUNITED = {};
if (!PUNITED.common) PUNITED.common = {};

(function () {
  // グローバル名前空間オブジェクトをローカルオブジェクトに置き換え
  var ns = PUNITED.common;
  var mediaQuery = matchMedia('(max-width: 679px)');
  ns.mediaQuery = mediaQuery;
  ns.body = document.querySelector('body');
  ns.header = document.querySelector('.site_header');
  ns.classes = {
    active: '--active',
    current: '--current',
    open: '--open',
    pcOpen: '--pc_open',
    spOpen: '--sp_open',
    noScroll: 'no_scroll',
    spNoScroll: 'sp_no_scroll',
    sticky: '--sticky'
  };
  /* -----------------------------------------------------
  	IEの場合にメッセージを表示
  ----------------------------------------------------- */

  var userAgent = window.navigator.userAgent.toLowerCase();

  if (userAgent.indexOf('trident') != -1 || userAgent.indexOf('msie') != -1) {
    $("html").addClass("regacy_ie");
  }

  ns.handleScrollbarSize = function () {
    PUNITED.utils.setScrollbarWidth();
    window.addEventListener('resize', function () {
      return PUNITED.utils.setScrollbarWidth();
    });
  };

  ns.handleHeaderNavToggle = function () {
    if (!ns.header) {
      return;
    }

    var toggle = ns.header.querySelector('[class*="__toggle"]');
    toggle.addEventListener('click', function () {
      var open = ns.header.classList.toggle(ns.classes.open); // if (!open && ns.sidebar && ns.sidebar.classList.contains('--sp_open')) {
      // 	open = true;
      // }

      ns.body.classList.toggle(ns.classes.spNoScroll, open);
    }); // ns.mediaQuery.addEventListener("change", (e) => {
    // 	if (!ns.header.classList.contains(ns.classes.open)) {
    // 		return;
    // 	}
    //
    // 	// ns.body.classList.toggle(ns.classes.spNoScroll, e.matches);
    // });
    // Click outside to close nav

    window.addEventListener('click', function (e) {
      if (ns.header.contains(e.target) || !ns.header.classList.contains(ns.classes.open)) {
        return;
      }

      var open = ns.header.classList.toggle(ns.classes.open);
      ns.body.classList.toggle(ns.classes.spNoScroll, open);
    });
  };
})();

$(function () {
  PUNITED.common.handleScrollbarSize();
  PUNITED.common.handleHeaderNavToggle();
});